import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, unref as _unref, withCtx as _withCtx, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
import { computed } from 'vue';
import { MenuItem as AMenuItem, SubMenu as ASubMenu } from 'ant-design-vue';
const __default__ = {
  name: 'XDropdownMenuItem'
};
export default /*@__PURE__*/Object.assign(__default__, {
  props: {
    title: {
      type: [String, Function],
      required: true
    },
    icon: {
      type: [String, Function],
      default: ''
    },
    loading: {
      type: [Boolean, Function],
      default: false
    },
    disabled: {
      type: [Boolean, Function],
      default: false
    },
    action: {
      type: [String, Function],
      default: ''
    },
    children: {
      type: Array,
      default: () => []
    }
  },
  emits: ['click'],
  setup(__props, {
    emit: __emit
  }) {
    const ADivider = AMenuItem.Divider;
    const props = __props;
    const emit = __emit;
    const isDivider = computed(() => {
      return menuTitle.value === '---';
    });
    const hasChild = computed(() => {
      return Array.isArray(props.children) && props.children.length > 0;
    });

    // 菜单标题
    const menuTitle = computed(() => {
      return typeof props.title === 'function' ? props.title() : props.title;
    });

    // 菜单项图标
    const menuIcon = computed(() => {
      return typeof props.icon === 'function' ? props.icon() : props.icon;
    });

    // 菜单项是否显示loading状态
    const menuLoading = computed(() => {
      return typeof props.loading === 'function' ? props.loading() : props.loading;
    });

    // 菜单项是否禁用
    const menuDisabled = computed(() => {
      return typeof props.disabled === 'function' ? props.disabled() : props.disabled;
    });
    const handleMenuClick = e => {
      emit('click', {
        ...props
      });
    };
    const handleMenuItemClick = item => {
      const {
        title,
        icon = '',
        loading = false,
        disabled = false,
        action = '',
        children
      } = item || {};
      emit('click', {
        title,
        icon,
        loading,
        disabled,
        action,
        children
      });
    };
    return (_ctx, _cache) => {
      const _component_x_dropdown_menu_item = _resolveComponent("x-dropdown-menu-item", true);
      return hasChild.value ? (_openBlock(), _createBlock(_unref(ASubMenu), {
        key: _ctx.$attrs.key,
        icon: menuIcon.value,
        title: menuTitle.value,
        loading: menuLoading.value,
        disabled: menuDisabled.value
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.children, (item, idx) => {
          return _openBlock(), _createBlock(_component_x_dropdown_menu_item, {
            key: idx,
            title: item.title,
            icon: item.icon,
            loading: item.loading,
            disabled: item.disabled,
            action: item.action,
            children: item.children,
            onClick: () => handleMenuItemClick(item)
          }, null, 8, ["title", "icon", "loading", "disabled", "action", "children", "onClick"]);
        }), 128))]),
        _: 1
      }, 8, ["icon", "title", "loading", "disabled"])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [isDivider.value ? (_openBlock(), _createBlock(_unref(ADivider), {
        key: 0
      })) : (_openBlock(), _createBlock(_unref(AMenuItem), {
        key: _ctx.$attrs.key,
        loading: menuLoading.value,
        disabled: menuDisabled.value,
        onClick: handleMenuClick
      }, {
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {}, () => [!!menuIcon.value ? (_openBlock(), _createBlock(_resolveDynamicComponent(menuIcon.value), {
          key: 0
        })) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(menuTitle.value), 1)])]),
        _: 3
      }, 8, ["loading", "disabled"]))], 64));
    };
  }
});